// import React from 'react';
// import ds from '@/styles/ds/ds.module.scss';

// type Props = {
// 	label?: string;
// 	labelProps?: React.LabelHTMLAttributes<HTMLLabelElement>;
// 	inputProps: React.InputHTMLAttributes<HTMLInputElement>;
// 	containerClassName?: string;
// 	error?: boolean;
// };

// const Input_Primary = ({
// 	label,
// 	labelProps,
// 	inputProps,
// 	containerClassName,
// 	error = false,
// }: Props) => {
// 	return (
// 		<div className={`flex flex-col gap-1 w-full ${containerClassName ?? ''}`}>
// 			{label && (
// 				<label
// 					{...labelProps}
// 					className={`${ds.label_primary} ${labelProps?.className ?? ''}`}
// 				>
// 					{label}
// 				</label>
// 			)}
// 			<input
// 				{...inputProps}
// 				className={`${ds.inputContainer} ${error ? ds.input_error_primary : null} h-10 !px-4 ${inputProps?.className ?? ''}`}
// 			/>
// 		</div>
// 	);
// };

// export default Input_Primary;

import React from 'react';
import ds from '@/styles/ds/ds.module.scss';

type Props = {
	label?: string;
	labelProps?: React.LabelHTMLAttributes<HTMLLabelElement>;
	inputProps: React.InputHTMLAttributes<HTMLInputElement>;
	containerClassName?: string;
	error?: boolean;
};

const Input_Primary = ({
	label,
	labelProps,
	inputProps,
	containerClassName,
	error = false,
}: Props) => {
	const { value, defaultValue, className, ...restInputProps } = inputProps;

	return (
		<div className={`flex flex-col gap-1 w-full ${containerClassName ?? ''}`}>
			{label && (
				<label
					{...labelProps}
					className={`${ds.label_primary} ${labelProps?.className ?? ''}`}
				>
					{label}
				</label>
			)}
			<input
				{...(value !== undefined ? { value } : { defaultValue })}
				{...restInputProps}
				className={`${ds.inputContainer} ${error ? ds.input_error_primary : ''} h-10 !px-4 ${className ?? ''}`}
			/>
		</div>
	);
};

export default Input_Primary;
